import React, {
	useState,
	SetStateAction,
	useLayoutEffect,
	useContext
} from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { MenuItemLocationProps } from 'types/MenuItemLocationProps';
import Modal from 'components/Modal';
import SimpleInput from 'components/SimpleInput';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { addNewItem, editItem } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { verifyForm } from './functions';

interface FormMenuItemLocationProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	itemMenuToEdit: null | MenuItemLocationProps;
	setItemMenuToEdit: React.Dispatch<
		SetStateAction<null | MenuItemLocationProps>
	>;
	setListMenuItensLocation: React.Dispatch<
		React.SetStateAction<MenuItemLocationProps[]>
	>;
}

const initialDataForm: MenuItemLocationProps = {
	created_at: '',
	updated_at: '',
	id: '',
	name: '',
	slug: ''
};

export default function FormMenuItemLocation({
	isOpen,
	setIsOpen,
	setItemMenuToEdit,
	itemMenuToEdit,
	setListMenuItensLocation
}: FormMenuItemLocationProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { t }: UseTranslationProps = useTranslation();
	const [dataForm, setDataForm] = useState(initialDataForm);

	function resetStatesComp() {
		setDataForm(initialDataForm);
		setItemMenuToEdit(null);
	}

	async function handleWithNewItem() {
		const canSave = verifyForm(dataForm, handleNotify);

		if (canSave) {
			setIsOpenLoad(true);
			setMessage('Salvando item de menu');

			const resp = await addNewItem(dataForm, handleNotify);
			setIsOpenLoad(false);

			if (resp.isSuccess) {
				setListMenuItensLocation((prev) => {
					const newList = [...prev];
					if (resp.data !== null) {
						newList.push(resp.data);
					}
					return newList;
				});
				setIsOpen(false);
				resetStatesComp();
			}
		}
	}

	async function handleWithEditItem() {
		if (dataForm !== null) {
			setIsOpenLoad(true);
			setMessage('Salvando item de menu');

			const resp = await editItem(dataForm, handleNotify);

			setIsOpenLoad(false);

			if (resp.isSuccess && resp.data !== null) {
				setListMenuItensLocation((listPre) => {
					const newList = listPre.map((item) => {
						if (item.id === resp.data?.id) {
							return resp.data;
						}
						return item;
					});

					return newList;
				});
				setIsOpen(false);
				resetStatesComp();
			}
		}
	}

	useLayoutEffect(() => {
		if (itemMenuToEdit !== null) {
			setDataForm({
				...itemMenuToEdit,
				name: itemMenuToEdit.name
			});
		}
	}, []);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
				resetStatesComp();
			}}
			title={t(
				itemMenuToEdit === null
					? 'menuItensLocation.formMenuItemLocation.addItem'
					: 'menuItensLocation.formMenuItemLocation.editItem'
			)}
			buttonClose={false}
		>
			<S.container>
				<SimpleInput
					initialValue={dataForm.name}
					label={t('menuItensLocation.formMenuItemLocation.name')}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, name: value }));
					}}
				/>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							setIsOpen(false);
							resetStatesComp();
						}}
					>
						{t('cancel')}
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={
							itemMenuToEdit === null ? handleWithNewItem : handleWithEditItem
						}
					>
						{t('save')}
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
